//@flow
import type {MessageContent, MessageType} from './message';

export type ConversationState = 'OPEN' | 'CLOSED' | 'ALL';

export type DeviceState =
  | 'CONNECTED'
  | 'DISCONNECTED'
  | 'CONNECTING'
  | 'ARCHIVED';

export type DeviceStatus =
  | 'DISCONNECTED'
  | 'CONNECTED'
  | 'CONNECTING'
  | 'ARCHIVED';

export type ChatServiceType =
  | 'WHATSAPP_WEB'
  | 'INSTAGRAM'
  | 'FB_MESSENGER'
  | 'WHATSAPP_API';

export const mediaTypes = {
  IMAGE: 'Image',
  VIDEO: 'Video',
  AUDIO: 'Audio',
  PTT: 'Audio',
  DOCUMENT: 'Document',
  STICKER: 'Image',
};

export type MetaUserResponse = {
  id: string,
  name: string,
  type: 'facebook-meta-user',
};

export type MetaUserRequest = {
  service: 'FB_MESSENGER' | 'INSTAGRAM' | 'WHATSAPP_API',
  code: string,
  metaAppMetaId: string,
  redirectUri: string,
};

export type StoreDevice = {
  id: string,
  identifier: string,
  type: 'raven-device',
  state: DeviceState,
  service: ChatServiceType,
  accountSynchronized: boolean,
  contactSynchronized: boolean,
  chatbotId?: string,
};

export type MetaAccount = {
  id: string,
  name: string,
};

export type MetaAccountResponse = {
  accounts: MetaAccount[],
};

/*
TODO: replace the above type with this one when the API is ready
export type StoreDevice = {
  id: string,
  identifier: string,
  type: ChatServiceType,
  state: DeviceState,
};
*/

export type ConversationTag = {
  createdAt: number,
  id: string,
  tag: string,
  type: 'crm-tag',
  updatedAt: number,
};
export type AddressRaw = {
  address1: string,
  address2: null,
  admin1: string,
  admin2: string,
  admin3: string,
  country: null,
  type: string,
  zipCode: null,
};

export type CRMCustomer = {
  averageOrderAmount: string,
  crmCustomerCategory: string,
  email: string,
  fullName: string,
  id: string,
  identificationNumber: null,
  identificationType: null,
  lastOrderDate: number,
  numberOfOrders: number,
  phone: string,
  totalOrderAmount: string,
  type: string,
};

export type CRMCustomerCategory = {
  color: string,
  id: string,
  name: string,
  type: 'crm-customer-category',
};

export type ContactInformation = {
  createdAt: number,
  firstName: string,
  fullName: string,
  phone: string,
  pushName: string,

  //META USER
  name?: string,
  username?: string,

  contactName?: string,
};
export type Conversation = {
  userId?: string,
  userType?: 'VENDOR' | 'COLLABORATOR',
  createdAt: number,
  crmCustomer?: CRMCustomer,
  id: string,
  lastMessageReceived: MessageContent,
  lastMessageReceivedAt: number,
  lastMessageReceivedType: MessageType,
  lastMessageSent: MessageContent,
  lastMessageSentAt: number,
  lastMessageSentType: MessageType,
  lastMessage: MessageContent,
  lastMessageType: MessageType,
  lastMessageAt: number,
  deviceIdentifier: string,
  identifier: string,
  // identifier?: string,
  ravenService: ChatServiceType,
  tags: ConversationTag[],
  type: string,
  funnel?: {
    id: string,
    name: string,
  },
  updatedAt: number,
  crmConversationState: ConversationState,
  contactInformation: ContactInformation,
  read: boolean,
  nextConversationId?: string,
  previousConversationId?: string,
  deviceId: string,
  disabledChatbot: boolean,
  requiresAssistance?: boolean,
  pinned?: boolean,
};

export type ConversationResponse = {
  userId?: string,
  userType?: 'VENDOR' | 'COLLABORATOR',
  createdAt: number,
  crmCustomer?: CRMCustomer,
  id: string,
  deviceId: string,
  lastMessageReceived: MessageContent,
  lastMessageReceivedAt: number,
  lastMessageReceivedType: MessageType,
  lastMessageSent: MessageContent,
  lastMessageSentAt: number,
  lastMessageSentType: MessageType,
  lastMessageAt: number,
  lastMessage: MessageContent,
  lastMessageType: MessageType,
  deviceIdentifier: string,
  ravenService: ChatServiceType,
  tags: ConversationTag[],
  type: string,
  updatedAt: number,
  crmConversationState: ConversationState,
  contactInformation: ContactInformation,
  read: boolean,
  disabledChatbot: boolean,
};
export type FileMessageType = {
  name: string,
  size: number,
  type: string,
};

/* export type ConversationMessage = {
  fromMe: boolean,
  messageType: MessageType,
  content?: string, //message = { content: string, messageType: MessageType }
  id: string,
  service: RavenService,
}; */

export type GetConversationCountParams = {
  services: ChatServiceType[],
  tags?: string[],
  state?: ConversationState,
  collaborators?: string[],
  admin?: 1 | 0,
};

type TemplateComponentRequest = {
  type: 'HEADER' | 'BODY',
  parameters: {
    type: 'TEXT',
    text: string,
  }[],
};
export type OpenConversationRequest = {
  identifier: string,
  provider: ChatServiceType,
  message: {
    text?: string,
    template?: string,
    templateLang?: string,
    components?: TemplateComponentRequest[],
  },
  deviceId: string,
  contactInformation: {
    fullName: string,
  },
};

export type ChatBot = {
  id: string,
  name: string,
  enabled: boolean,
  provider: string,
  ragLastSyncAt?: string,
};

export * from './message';
export * from './schedule-messages';
